import { InstallOculeraCommand } from './commands/install-oculera.command';
import { ShellCommand } from './commands/shell.command';
import { WriteFileCommand } from './commands/writeFile.command';
import { Procedure } from './procedure.interface';
import { RESET_COMMANDS } from './reset';

export const INSTALL_OCULERA: Procedure = {
  name: 'Oculera',
  resetCommands: RESET_COMMANDS,
  commands: [
    new InstallOculeraCommand(),
    new WriteFileCommand('/sdcard/config.txt', 'open_guide:0\n------\nhome_pkg:com.Oculera.perimetryVR20\n------\n'),
    new ShellCommand('mkdir -p /sdcard/SeethroughSetting/Config'),
    new WriteFileCommand(
      '/sdcard/SeethroughSetting/Config/Config1.txt',
      'AutoDelete 0\nForceTOC 0\nForceNOUI 1\nForceReset6Dof 1\nheight 1.65\nForceClose 0\nForceStart 0\n#circle_r 10000\n#circle_pcount 36',
    ),
  ],
  validationCommands: [],
};
